module.exports = "/desktop-app/assets/img/email.png?407de608001f998be1a56ffbfe23d7ba";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/images/icon/email.png
// module id = pCmJ
// module chunks = 1